import { Sector } from '@/domain/impact/impact.entity';
import {
  Category,
  ImpactCo2Answer,
  ValuesWater,
} from '@/domain/impact-co2/entities/question.entity';

import { ImportedRow } from '../convert-excel-to-impact-answers';
import { buildBaseAnswer } from './common/build-base-answer';
import {
  filterRowsByCategory,
  filterRowsBySectors,
} from './common/filter-rows-by-category';
import { ImportMappingError } from './common/import-mapping.error';

const CATEGORY: Category = 'WATER';
const SECTORS: Sector[] = ['SITE'];

export function mapToWaterAnswers(
  rows: ImportedRow[],
): ImpactCo2Answer<ValuesWater>[] {
  return rows
    .filter(filterRowsByCategory(CATEGORY))
    .filter(filterRowsBySectors(SECTORS))
    .map((row) => buildAnswer(row));
}

function buildAnswer(row: ImportedRow) {
  const waterConsumptionVolume = mapToWaterConsumptionVolume(row);
  const baseAnswer = buildBaseAnswer(row, CATEGORY);
  const answer = {
    ...baseAnswer,
    values: {
      ...baseAnswer.values,
      waterConsumptionVolume,
    },
  };
  return answer;
}

function mapToWaterConsumptionVolume(row: ImportedRow): number {
  const tgsValue = row['Volume (L)'];
  const result = parseInt(tgsValue, 10);
  if (isNaN(result)) {
    throw new ImportMappingError('waterConsumptionVolume', tgsValue, row);
  }
  return result;
}
